'use strict';

/**
 * FormElement
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.FormElement = T.createModule({

	_selectors: {
		field: '[data-js-form-element__field]',
		select: '.form-select:not(.state-hidden)'
	},

	_stateClasses: {
		focused: 'state-focused',
		notEmpty: 'state-not-empty'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$fields = this.$ctx.find(this._selectors.field);
		this.$select = this.$ctx.find(this._selectors.select);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));

		// Component Event Binding
		this.$fields.on('focus', this.$onFocusField.bind(this));
		this.$fields.on('blur', this.$onLostFocusField.bind(this));

		// Iinit
		this.updateFieldStatus();
		this.initSelect2();

		resolve();
	},
	sync: function sync() {},
	initSelect2: function initSelect2() {
		if (this.$select.length > 0) {
			this.$select.select2({
				allowClear: false
			});
		}
	},
	$onFocusField: function $onFocusField() {
		this.$ctx.addClass(this._stateClasses.focused);
	},
	$onLostFocusField: function $onLostFocusField() {
		this.$ctx.removeClass(this._stateClasses.focused);
		this.updateFieldStatus();
	},
	updateFieldStatus: function updateFieldStatus() {
		var hasValue = false;

		// Check all input fields if at least one value set
		this.$fields.each(function (index, element) {
			var $element = $(element);
			var val = $element.val();
			if (val && val.length) {
				hasValue = true;

				// Break each
				return false;
			}
		});

		if (hasValue) {
			this.$ctx.addClass(this._stateClasses.notEmpty);
		} else {
			this.$ctx.removeClass(this._stateClasses.notEmpty);
		}
	}
});